// AUTO-GENERATED by scripts/gen-coda.ts, do not edit by hand.
// CODA, chapter 14: 20 simulator-verified single-winner levels, ramped by solver search effort.
// The first five use only kinds seen in chapters 1 to 3; the later fifteen combine known kinds.
// Regenerate with: npx tsx scripts/gen-coda.ts
import type { LevelDef } from '../sim/types';

export const CODA_LEVELS: LevelDef[] = [
  {
    id: 'k1',
    name: "Reprise",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"r1","x":900,"y":1580,"type":"required","label":"R1"},
    {"id":"p1","x":900,"y":980,"type":"protected","label":"P1"},
    {"id":"m1","x":420,"y":980,"type":"normal","label":"M1"},
    {"id":"p2","x":180,"y":1280,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"p1","type":"directional"},
    {"id":"w2","a":"m1","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'k2',
    name: "Da Capo",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":900,"y":380,"type":"normal","label":"S2"},
    {"id":"r1","x":900,"y":1580,"type":"required","label":"R1"},
    {"id":"h1","x":180,"y":680,"type":"normal","label":"H1","conduit":true},
    {"id":"h2","x":180,"y":980,"type":"normal","label":"H2","conduit":true},
    {"id":"x1","x":900,"y":1280,"type":"normal","label":"X1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"h1","type":"directional"},
    {"id":"w1","a":"h1","b":"h2","type":"directional"},
    {"id":"w2","a":"h2","b":"r1","type":"directional"},
    {"id":"w3","a":"s2","b":"x1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'k3',
    name: "Segno",
    tier: 'easy',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":900,"y":380,"type":"normal","label":"S2"},
    {"id":"r1","x":900,"y":1580,"type":"required","label":"R1"},
    {"id":"h1","x":660,"y":980,"type":"normal","label":"H1","conduit":true},
    {"id":"m1","x":420,"y":980,"type":"normal","label":"M1"},
    {"id":"p1","x":420,"y":1280,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"h1","type":"directional"},
    {"id":"w1","a":"h1","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"m1","type":"directional"},
    {"id":"w3","a":"m1","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'k4',
    name: "Fermata",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":900,"y":1580,"type":"required","label":"R1"},
    {"id":"m1","x":900,"y":980,"type":"normal","label":"M1"},
    {"id":"p1","x":420,"y":1280,"type":"protected","label":"P1"},
    {"id":"p2","x":180,"y":1280,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"m1","type":"directional"},
    {"id":"w2","a":"m1","b":"p1","type":"directional"},
    {"id":"w3","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'k5',
    name: "Refrain",
    tier: 'medium',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":660,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"h1","x":180,"y":980,"type":"normal","label":"H1","conduit":true},
    {"id":"m1","x":660,"y":980,"type":"normal","label":"M1"},
    {"id":"p1","x":660,"y":1280,"type":"protected","label":"P1"},
    {"id":"p2","x":420,"y":980,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"h1","type":"directional"},
    {"id":"w1","a":"h1","b":"r1","type":"directional"},
    {"id":"w2","a":"s3","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"m1","type":"directional"},
    {"id":"w4","a":"m1","b":"p1","type":"directional"},
    {"id":"w5","a":"s2","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'k6',
    name: "Ostinato",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":660,"y":1580,"type":"required","label":"R1","threshold":3,"decay":4},
    {"id":"sp1","x":660,"y":980,"type":"splitter","label":"SP1","splitFactor":3},
    {"id":"x1","x":180,"y":680,"type":"normal","label":"X1"},
    {"id":"p1","x":900,"y":980,"type":"protected","label":"P1"},
    {"id":"m1","x":900,"y":1280,"type":"normal","label":"M1"},
    {"id":"p2","x":420,"y":980,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"sp1","type":"directional"},
    {"id":"w1","a":"sp1","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"x1","type":"directional"},
    {"id":"w3","a":"s3","b":"sp1","type":"directional"},
    {"id":"w4","a":"s3","b":"p1","type":"directional"},
    {"id":"w5","a":"m1","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'k7',
    name: "Stretto",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":900,"y":1580,"type":"required","label":"R1"},
    {"id":"rel1","x":900,"y":680,"type":"relay","label":"REL1","unlocks":["w0"]},
    {"id":"x1","x":420,"y":680,"type":"normal","label":"X1"},
    {"id":"m1","x":660,"y":680,"type":"normal","label":"M1"},
    {"id":"p1","x":180,"y":1280,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"rel1","b":"r1","type":"locked"},
    {"id":"w1","a":"s2","b":"rel1","type":"directional"},
    {"id":"w2","a":"s1","b":"x1","type":"directional"},
    {"id":"w3","a":"s3","b":"m1","type":"directional"},
    {"id":"w4","a":"m1","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'k8',
    name: "Cadenza",
    tier: 'hard',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":900,"y":1580,"type":"required","label":"R1"},
    {"id":"sh1","x":900,"y":980,"type":"shield","label":"SH1","shields":["r1"]},
    {"id":"m1","x":420,"y":980,"type":"normal","label":"M1"},
    {"id":"p1","x":660,"y":980,"type":"protected","label":"P1"},
    {"id":"x1","x":180,"y":680,"type":"normal","label":"X1"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sh1","type":"directional"},
    {"id":"w1","a":"s2","b":"r1","type":"delay"},
    {"id":"w2","a":"s1","b":"m1","type":"directional"},
    {"id":"w3","a":"m1","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"x1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'k9',
    name: "Tutti",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":660,"y":1580,"type":"required","label":"R1","threshold":2,"decay":4},
    {"id":"cap1","x":420,"y":980,"type":"capacitor","label":"CAP1"},
    {"id":"h1","x":900,"y":680,"type":"normal","label":"H1","conduit":true},
    {"id":"m1","x":180,"y":980,"type":"normal","label":"M1"},
    {"id":"p1","x":900,"y":1280,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"cap1","type":"directional"},
    {"id":"w1","a":"s2","b":"h1","type":"directional"},
    {"id":"w2","a":"cap1","b":"r1","type":"delay"},
    {"id":"w3","a":"h1","b":"r1","type":"delay"},
    {"id":"w4","a":"s1","b":"r1","type":"forbidden"},
    {"id":"w5","a":"s3","b":"m1","type":"directional"},
    {"id":"w6","a":"m1","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'k10',
    name: "Rubato",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"r2","x":900,"y":1580,"type":"required","label":"R2"},
    {"id":"h1","x":420,"y":980,"type":"normal","label":"H1","conduit":true},
    {"id":"core1","x":660,"y":1580,"type":"core","label":"CORE1","threshold":3,"decay":4},
    {"id":"sh1","x":420,"y":680,"type":"shield","label":"SH1","shields":["core1"]},
    {"id":"sp1","x":180,"y":980,"type":"splitter","label":"SP1","splitFactor":3}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"r1","type":"directional"},
    {"id":"w1","a":"s1","b":"h1","type":"directional"},
    {"id":"w2","a":"h1","b":"r2","type":"directional"},
    {"id":"w3","a":"s1","b":"sh1","type":"directional"},
    {"id":"w4","a":"s1","b":"sp1","type":"directional"},
    {"id":"w5","a":"sp1","b":"core1","type":"directional"},
    {"id":"w6","a":"s2","b":"sp1","type":"directional"},
    {"id":"w7","a":"s2","b":"r2","type":"forbidden"},
    {"id":"w8","a":"s3","b":"r1","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"],"coreNodeId":"core1"},
  },
  {
    id: 'k11',
    name: "Cantus",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":900,"y":1580,"type":"required","label":"R1","threshold":3,"decay":4},
    {"id":"r2","x":180,"y":1280,"type":"required","label":"R2"},
    {"id":"sp1","x":420,"y":680,"type":"splitter","label":"SP1","splitFactor":3},
    {"id":"rel1","x":180,"y":980,"type":"relay","label":"REL1","unlocks":["w2"]},
    {"id":"p1","x":900,"y":1280,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"sp1","type":"directional"},
    {"id":"w1","a":"sp1","b":"r1","type":"directional"},
    {"id":"w2","a":"rel1","b":"r2","type":"locked"},
    {"id":"w3","a":"s1","b":"rel1","type":"directional"},
    {"id":"w4","a":"s2","b":"sp1","type":"directional"},
    {"id":"w5","a":"s2","b":"r1","type":"forbidden"},
    {"id":"w6","a":"s3","b":"sp1","type":"directional"},
    {"id":"w7","a":"s3","b":"p1","type":"directional"},
    {"id":"w8","a":"s4","b":"r2","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1","r2"]},
  },
  {
    id: 'k12',
    name: "Tremolo",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2,"decay":4},
    {"id":"cap1","x":660,"y":980,"type":"capacitor","label":"CAP1"},
    {"id":"h1","x":900,"y":980,"type":"normal","label":"H1","conduit":true},
    {"id":"m1","x":420,"y":980,"type":"normal","label":"M1"},
    {"id":"p1","x":900,"y":1280,"type":"protected","label":"P1"},
    {"id":"p2","x":180,"y":1280,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"cap1","type":"directional"},
    {"id":"w1","a":"s3","b":"h1","type":"directional"},
    {"id":"w2","a":"cap1","b":"r1","type":"delay"},
    {"id":"w3","a":"h1","b":"r1","type":"delay"},
    {"id":"w4","a":"s1","b":"m1","type":"directional"},
    {"id":"w5","a":"m1","b":"p1","type":"directional"},
    {"id":"w6","a":"s2","b":"h1","type":"directional"},
    {"id":"w7","a":"s2","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'k13',
    name: "Sforzando",
    tier: 'expert',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":900,"y":1580,"type":"required","label":"R1"},
    {"id":"sh1","x":660,"y":680,"type":"shield","label":"SH1","shields":["r1"]},
    {"id":"m1","x":180,"y":680,"type":"normal","label":"M1"},
    {"id":"p1","x":420,"y":980,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"sh1","type":"directional"},
    {"id":"w1","a":"s2","b":"r1","type":"delay"},
    {"id":"w2","a":"s1","b":"sh1","type":"directional"},
    {"id":"w3","a":"s1","b":"r1","type":"forbidden"},
    {"id":"w4","a":"s3","b":"m1","type":"directional"},
    {"id":"w5","a":"m1","b":"p1","type":"directional"},
    {"id":"w6","a":"s4","b":"sh1","type":"directional"},
    {"id":"w7","a":"s4","b":"r1","type":"forbidden"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'k14',
    name: "Hemiola",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":900,"y":1580,"type":"required","label":"R1","threshold":2,"decay":4},
    {"id":"cap1","x":420,"y":980,"type":"capacitor","label":"CAP1"},
    {"id":"h1","x":900,"y":980,"type":"normal","label":"H1","conduit":true},
    {"id":"x1","x":660,"y":980,"type":"normal","label":"X1"},
    {"id":"m1","x":180,"y":980,"type":"normal","label":"M1"},
    {"id":"p1","x":180,"y":1280,"type":"protected","label":"P1"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"cap1","type":"directional"},
    {"id":"w1","a":"s1","b":"h1","type":"directional"},
    {"id":"w2","a":"cap1","b":"r1","type":"delay"},
    {"id":"w3","a":"h1","b":"r1","type":"delay"},
    {"id":"w4","a":"s2","b":"x1","type":"directional"},
    {"id":"w5","a":"s3","b":"m1","type":"directional"},
    {"id":"w6","a":"m1","b":"p1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'k15',
    name: "Canon",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":660,"y":1580,"type":"required","label":"R1","threshold":3,"decay":4},
    {"id":"sp1","x":660,"y":680,"type":"splitter","label":"SP1","splitFactor":3},
    {"id":"p1","x":180,"y":1280,"type":"protected","label":"P1"},
    {"id":"x1","x":900,"y":680,"type":"normal","label":"X1"},
    {"id":"m1","x":180,"y":680,"type":"normal","label":"M1"},
    {"id":"p2","x":420,"y":980,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s1","b":"sp1","type":"directional"},
    {"id":"w1","a":"sp1","b":"r1","type":"directional"},
    {"id":"w2","a":"s2","b":"sp1","type":"directional"},
    {"id":"w3","a":"s2","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"x1","type":"directional"},
    {"id":"w5","a":"m1","b":"p2","type":"directional"},
    {"id":"w6","a":"s3","b":"m1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'k16',
    name: "Fugue",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"rel1","x":420,"y":980,"type":"relay","label":"REL1","unlocks":["w0"]},
    {"id":"p1","x":660,"y":680,"type":"protected","label":"P1"},
    {"id":"m1","x":900,"y":980,"type":"normal","label":"M1"},
    {"id":"p2","x":660,"y":980,"type":"protected","label":"P2"},
    {"id":"x1","x":900,"y":680,"type":"normal","label":"X1"}
    ],
    wires: [
    {"id":"w0","a":"rel1","b":"r1","type":"locked"},
    {"id":"w1","a":"s1","b":"rel1","type":"directional"},
    {"id":"w2","a":"s2","b":"rel1","type":"directional"},
    {"id":"w3","a":"s2","b":"p1","type":"directional"},
    {"id":"w4","a":"s3","b":"m1","type":"directional"},
    {"id":"w5","a":"m1","b":"p2","type":"directional"},
    {"id":"w6","a":"s4","b":"x1","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'k17',
    name: "Crescendo",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1"},
    {"id":"core1","x":900,"y":1580,"type":"core","label":"CORE1","threshold":3,"decay":4},
    {"id":"sh1","x":180,"y":680,"type":"shield","label":"SH1","shields":["core1"]},
    {"id":"sp1","x":180,"y":1280,"type":"splitter","label":"SP1","splitFactor":3},
    {"id":"m1","x":660,"y":680,"type":"normal","label":"M1"},
    {"id":"p1","x":660,"y":980,"type":"protected","label":"P1"},
    {"id":"p2","x":900,"y":680,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"sh1","type":"directional"},
    {"id":"w2","a":"s2","b":"sp1","type":"directional"},
    {"id":"w3","a":"sp1","b":"core1","type":"directional"},
    {"id":"w4","a":"s1","b":"m1","type":"directional"},
    {"id":"w5","a":"m1","b":"p1","type":"directional"},
    {"id":"w6","a":"s3","b":"sp1","type":"directional"},
    {"id":"w7","a":"s3","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"],"coreNodeId":"core1"},
  },
  {
    id: 'k18',
    name: "Perpetuo",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":420,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":660,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":900,"y":380,"type":"normal","label":"S3"},
    {"id":"r1","x":660,"y":1580,"type":"required","label":"R1","threshold":3,"decay":4},
    {"id":"sp1","x":180,"y":680,"type":"splitter","label":"SP1","splitFactor":3},
    {"id":"core1","x":180,"y":1580,"type":"core","label":"CORE1","threshold":3,"decay":4},
    {"id":"sh1","x":900,"y":980,"type":"shield","label":"SH1","shields":["core1"]},
    {"id":"sp2","x":660,"y":980,"type":"splitter","label":"SP2","splitFactor":3},
    {"id":"p1","x":660,"y":680,"type":"protected","label":"P1"},
    {"id":"p2","x":180,"y":1280,"type":"protected","label":"P2"},
    {"id":"m1","x":660,"y":1280,"type":"normal","label":"M1"},
    {"id":"p3","x":900,"y":1280,"type":"protected","label":"P3"}
    ],
    wires: [
    {"id":"w0","a":"s3","b":"sp1","type":"directional"},
    {"id":"w1","a":"sp1","b":"r1","type":"directional"},
    {"id":"w2","a":"s3","b":"sh1","type":"directional"},
    {"id":"w3","a":"s3","b":"sp2","type":"directional"},
    {"id":"w4","a":"sp2","b":"core1","type":"directional"},
    {"id":"w5","a":"s1","b":"p1","type":"directional"},
    {"id":"w6","a":"s2","b":"p2","type":"directional"},
    {"id":"w7","a":"m1","b":"p3","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"],"coreNodeId":"core1"},
  },
  {
    id: 'k19',
    name: "Finale",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":420,"y":1580,"type":"required","label":"R1","threshold":2,"decay":4},
    {"id":"cap1","x":420,"y":680,"type":"capacitor","label":"CAP1"},
    {"id":"h1","x":180,"y":980,"type":"normal","label":"H1","conduit":true},
    {"id":"x1","x":660,"y":680,"type":"normal","label":"X1"},
    {"id":"m1","x":900,"y":980,"type":"normal","label":"M1"},
    {"id":"p1","x":660,"y":1280,"type":"protected","label":"P1"},
    {"id":"p2","x":660,"y":980,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"cap1","type":"directional"},
    {"id":"w1","a":"s2","b":"h1","type":"directional"},
    {"id":"w2","a":"cap1","b":"r1","type":"delay"},
    {"id":"w3","a":"h1","b":"r1","type":"delay"},
    {"id":"w4","a":"s1","b":"x1","type":"directional"},
    {"id":"w5","a":"s3","b":"m1","type":"directional"},
    {"id":"w6","a":"m1","b":"p1","type":"directional"},
    {"id":"w7","a":"s4","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"]},
  },
  {
    id: 'k20',
    name: "Fine",
    tier: 'brutal',
    nodes: [
    {"id":"s1","x":180,"y":380,"type":"normal","label":"S1"},
    {"id":"s2","x":420,"y":380,"type":"normal","label":"S2"},
    {"id":"s3","x":660,"y":380,"type":"normal","label":"S3"},
    {"id":"s4","x":900,"y":380,"type":"normal","label":"S4"},
    {"id":"r1","x":660,"y":1580,"type":"required","label":"R1"},
    {"id":"core1","x":900,"y":1580,"type":"core","label":"CORE1","threshold":3,"decay":4},
    {"id":"sh1","x":420,"y":980,"type":"shield","label":"SH1","shields":["core1"]},
    {"id":"sp1","x":660,"y":980,"type":"splitter","label":"SP1","splitFactor":3},
    {"id":"x1","x":180,"y":680,"type":"normal","label":"X1"},
    {"id":"p1","x":180,"y":980,"type":"protected","label":"P1"},
    {"id":"x2","x":900,"y":680,"type":"normal","label":"X2"},
    {"id":"m1","x":900,"y":980,"type":"normal","label":"M1"},
    {"id":"p2","x":180,"y":1280,"type":"protected","label":"P2"}
    ],
    wires: [
    {"id":"w0","a":"s2","b":"r1","type":"directional"},
    {"id":"w1","a":"s2","b":"sh1","type":"directional"},
    {"id":"w2","a":"s2","b":"sp1","type":"directional"},
    {"id":"w3","a":"sp1","b":"core1","type":"directional"},
    {"id":"w4","a":"s1","b":"x1","type":"directional"},
    {"id":"w5","a":"s3","b":"sh1","type":"directional"},
    {"id":"w6","a":"s3","b":"p1","type":"directional"},
    {"id":"w7","a":"s4","b":"x2","type":"directional"},
    {"id":"w8","a":"m1","b":"p2","type":"directional"}
    ],
    objective: {"requiredNodeIds":["r1"],"coreNodeId":"core1"},
  }
];
